import type { SelectOptionType } from "@bp/ui-components/dist/@bp/lib/Select/Select";

/** Minimal account (User) shape the option label needs. */
export type LinkableAccount = {
  uuid: string;
  email: string;
  profiles: ReadonlyArray<{ organization: { name: string } | null }>;
};

/**
 * `anna@schule.de — 2 Profile: Gesamtschule, Gymnasium`. All accounts are
 * offered; already linked profiles are context, not a reason to hide the account.
 */
export function accountOptionLabel(account: LinkableAccount): string {
  if (account.profiles.length === 0) {
    return `${account.email} — kein Profil`;
  }
  const orgs = [
    ...new Set(
      account.profiles
        .map((p) => p.organization?.name)
        .filter((name): name is string => Boolean(name)),
    ),
  ];
  const suffix = orgs.length > 0 ? `: ${orgs.join(", ")}` : "";
  const noun = account.profiles.length === 1 ? "Profil" : "Profile";
  return `${account.email} — ${account.profiles.length} ${noun}${suffix}`;
}

export function accountOptions(
  accounts: ReadonlyArray<LinkableAccount> | undefined,
): SelectOptionType[] {
  return (accounts ?? []).map((a) => ({ value: a.uuid, label: accountOptionLabel(a) }));
}
